import React from 'react';
import { Mui } from '@osu/react-ui';
import StepField from './StepField';
import StepActions from '../forms/StepActions';

/**
 * StepContent Component for V2
 * Renders step content with fields and actions (fallback for non-template steps)
 */
function StepContent({ step, onAction }) {
  if (!step || !step.content) {
    return (
      <Mui.Typography variant="body2" color="text.secondary">
        No content available for this step.
      </Mui.Typography>
    );
  }

  const { content, actions = [] } = step;

  return (
    <Mui.Box>
      {/* Step Description */}
      {content.description && (
        <Mui.Typography variant="body1" paragraph>
          {content.description}
        </Mui.Typography>
      )}

      {/* Step Message */}
      {content.message && (
        <Mui.Alert severity="info" sx={{ mb: 2 }}>
          {content.message}
        </Mui.Alert>
      )}

      {/* Step Fields */}
      {content.fields && content.fields.length > 0 && (
        <Mui.Box sx={{ mb: 3 }}>
          {content.fields.map((field, index) => (
            <StepField key={index} field={field} />
          ))}
        </Mui.Box>
      )}

      {/* Step Actions */}
      {actions.length > 0 && (
        <StepActions 
          actions={actions} 
          onAction={onAction}
          stepId={step.id}
        />
      )}

      {/* Additional Info */}
      {content.additionalInfo && (
        <Mui.Box sx={{ mt: 2, p: 2, backgroundColor: 'grey.50', borderRadius: 1 }}>
          <Mui.Typography variant="body2" color="text.secondary">
            {content.additionalInfo}
          </Mui.Typography>
        </Mui.Box>
      )}
    </Mui.Box>
  );
}

export default StepContent;